<template>
  <div>
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-1 hover:text-danger cursor-pointer"
      @click="visible = true"
    />
    <vs-prompt
      vs-title="Müşteri Sil"
      vs-button-cancel="border"
      vs-cancel-text="Vazgeç"
      vs-accept-text="Sil"
      @vs-close="cancel"
      @vs-cancel="cancel"
      @vs-accept="deleteRecord(params.data.customerId)"
      vs-color="danger"
      :vs-active.sync="visible"
    >
      <div class="vx-row ml-5 mr-5">
        <p>
          {{ params.data.firstName }} adlı kullanıcıyı silmek istiyor musunuz ?
        </p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  data() {
    return {
      visible: false,
    };
  },
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router
        .push("/contactsEdit/" + this.params.data.customerId)
        .catch(() => {});
    },
    cancel() {
      this.visible = false;
    },
    deleteRecord: async function (id) {
      let r = await repository.deleteWithParam(
        "B2B/delete?customerId",
        id
      );
      if (r && r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Tamamlandı",
          text: `"${this.params.data.firstName}" Başarıyla Silindi.`,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `"${this.params.data.firstName}" silme işlemi tamamlanamadı`,
        });
      }
    },
  },
};
</script>
